import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import MenuButton from "../../components/MenuButton/MenuButton";
import "../../styles/globals.css";
import "./ReservationMenuPage.css";
import { getReservationMenus } from "../../services/service";

/**
 * 予約メニュー画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function ReservationMenuPage() {
  const {
    setGlobalMedicalInstitutionId,
    setGlobalMedicalInstitutionName,
    globalMedicalInstitutionName,
    globalReservationMenus,
    setGlobalReservationMenus,
    setGlobalSelectMenu,
    globalLoading,
  } = useContext(AppContext);
  const navigate = useNavigate();

  /**
   * コンポーネントがマウントされた時にデータを取得
   */
  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1)); // '#'を除去してから解析
    const medicalInstitutionId = params.get("medicalInstitutionId") || null;

    // データ読込処理
    const loadDatas = async () => {
      try {
        // 予約メニュー一覧情報取得
        const reservationMenus = await getReservationMenus(
          medicalInstitutionId
        );

        setGlobalMedicalInstitutionId(medicalInstitutionId);
        setGlobalMedicalInstitutionName(reservationMenus.data.name);
        setGlobalReservationMenus(reservationMenus.data.reservationMenus);
      } catch (error) {
        console.error("Error load data:", error);
      }
    };

    if (!globalLoading) {
      loadDatas();
    }
  }, [globalLoading]);

  /**
   * メニューボタンクリック時
   * @param {*} selectMenu 選択メニュー情報
   * @return {}  なし
   */
  const handleMenuClick = (selectMenu) => {
    // 選択診療科情報保持
    setGlobalSelectMenu(selectMenu);

    // 初診・再診選択画面に遷移
    navigate("/appointment-select");
  };

  return (
    <div className="reservation-menu">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      {globalReservationMenus && globalReservationMenus.length > 0 ? (
        // メニューあり
        <div className="main-area">
          <div className="title">予約メニューを選択</div>
          <div className="menu-buttons">
            {globalReservationMenus.map((menu) => (
              <MenuButton
                key={menu.reservationMenuId}
                className="menu-button"
                buttonLabel={menu.reservationMenuName}
                onClick={() => handleMenuClick(menu)}
              />
            ))}
          </div>
        </div>
      ) : (
        // メニューなし
        <div className="none-data">予約メニューがありません</div>
      )}
    </div>
  );
}

export default ReservationMenuPage;
